module.exports = __webpack_public_path__ + "static/media/motion-design-spinning-top.53d0cbdb.svg";